module.exports = "<select data-topics-select multiple data-holiday-exclusion-select></select>\n"